import { useAppDispatch, useAppSelector } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
import { useCallback } from "react";
import { MerchantOrderForm } from "./api";
import { getMerchantOrders } from "./slice";

export const useMerchantOrders = () => {
  const userId = useUserId();
  const state = useAppSelector((state) => state.merchantOrder);
  const dispatch = useAppDispatch();

  const getMerchantOrdersHandler = useCallback(
    (data?: MerchantOrderForm) => dispatch(getMerchantOrders({ userId, data })),
    [dispatch, userId]
  );

  return {
    state,
    getMerchantOrders: getMerchantOrdersHandler,
  };
};
